module.exports = __webpack_public_path__ + "static/media/logo-FC-dark_horizontal_bloemisten.4ad07c9d.svg";